export const ROLES = {
  SUPER_ADMIN: 'superAdmin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  COMPANY_USER: 'companyUser'
}

export const DEVICE_STATUS = { //need to revisit after discussion with DT team
  available: 3,
  missing: 1,
  beingFound: 2,
  inUse: 3,
  lost: 4,
  rma: 5,
  decommission: 9999,
  recommission: 0
}

export const ACTIONS_LIST = [{key:'lost', value: 'Lost'}, {key:'rma', value: 'Decomission/Recomission'}];

export const DEFAULT_ROWS_PER_PAGE = 10;

